import { render, staticRenderFns } from "./IndicatorList.vue?vue&type=template&id=6cea7dfa"
import script from "./IndicatorList.vue?vue&type=script&lang=js"
export * from "./IndicatorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports